@if (copy(); as copy) {
<nz-modal [nzVisible]="true" [nzWidth]="680" nzCentered [nzBodyStyle]="bodyStyle"
    [nzTitle]="'Move selection to ' + copy.label"
    [nzOkText]="copy.okText" nzOkDanger [nzOkDisabled]="!canConfirm()" (nzOnCancel)="close()" (nzOnOk)="confirm()">
    <ng-container *nzModalContent>
        <nz-alert nzType="warning" nzShowIcon [nzMessage]="copy.warning" />

        <p class="summary">
            <nz-tag><nz-icon nzType="cloud-server" /> s3://{{ bucket() }}</nz-tag>
        </p>

        <p class="summary">
            {{ folders().length }} folder(s) ·
            {{ eligibleFiles().length }} file(s)
            @if (skippedFiles().length) {
            · <strong>{{ skippedFiles().length }} already archived, skipped</strong>
            }
        </p>

        @if (folders().length) {
        <h4>Folders</h4>
        <p class="hint">
            Every Standard object under these prefixes is included. Sizes are unknown here — the
            server expands each prefix when the job runs.
        </p>
        <nz-list nzSize="small" nzBordered>
            @for (folder of folders(); track folder.key) {
            <nz-list-item>
                <nz-icon nzType="folder" />
                <span class="key">{{ folder.key }}</span>
                <nz-tag>all objects</nz-tag>
            </nz-list-item>
            }
        </nz-list>
        }

        @if (eligibleFiles().length) {
        <h4>Files — {{ eligibleBytes() | formatBytes }}</h4>
        <nz-list nzSize="small" nzBordered>
            @for (file of eligibleFiles().slice(0, maxListed); track file.key) {
            <nz-list-item>
                <nz-icon nzType="file" />
                <span class="key">{{ file.key }}</span>
                <span>{{ file.origin.size | formatBytes }}</span>
            </nz-list-item>
            }
            @if (eligibleFiles().length > maxListed) {
            <nz-list-item>+ {{ eligibleFiles().length - maxListed }} more</nz-list-item>
            }
        </nz-list>
        }

        @if (skippedFiles().length) {
        <h4>Skipped</h4>
        <p class="hint">
            Already in an archive class. Re-transitioning costs a per-object fee for no benefit,
            so these are left alone.
        </p>
        <nz-list nzSize="small" nzBordered>
            @for (file of skippedFiles().slice(0, maxListed); track file.key) {
            <nz-list-item>
                <nz-icon nzType="file" />
                <span class="key">{{ file.key }}</span>
                <nz-tag>{{ file.origin.storage_class }}</nz-tag>
            </nz-list-item>
            }
            @if (skippedFiles().length > maxListed) {
            <nz-list-item>+ {{ skippedFiles().length - maxListed }} more</nz-list-item>
            }
        </nz-list>
        }

        @if (!folders().length && !eligibleFiles().length) {
        <nz-alert nzType="info" nzShowIcon
            nzMessage="Nothing to do — every selected file is already in an archive class." />
        }

        @if (target() === 'DEEP_ARCHIVE') {
        <label nz-checkbox class="acknowledge" [nzChecked]="acknowledged()"
            (nzCheckedChange)="acknowledged.set($event)">
            I understand these objects cannot be read for up to 12 hours after a restore.
        </label>
        }
    </ng-container>
</nz-modal>
}
